<template>
  <base-modal height="600"
              :show="show"
              @close="close">
    <div slot="header" class="header">
      <div class="modal-name">
        {{ $t("appSettings.title") }}
      </div>

      <base-switch v-model="selectedAppType"
                   :options="appTypes" />
    </div>
    <app-settings :app-type="appType"
                  :mode-id="fromBus.modeId"
                  :child-id="fromBus.childId" />
  </base-modal>
</template>

<script>
  import AppSettings from '@/components/Child/ChildAppSettings/AppSettings.vue'
  import modalMixin from '@/mixins/modalMixin.js'

  export default {
    mixins: [
      modalMixin
    ],

    components: {
      AppSettings
    },

    data() {
      return {
        appTypes: [
          { key: 'android', value: 'Android' },
          { key: 'ios', value: 'iOS' }
        ],
        selectedAppType: null,
        appType: '',

        fromBus: {
          modeId: '',
          childId: ''
        }
      }
    },

    created() {
      this.selectedAppType = this.appTypes[0]
    },

    watch: {
      selectedAppType(item) {
        this.appType = item.key
      }
    },

    beforeMount() {
      this.setOpenListener('apps')
    }
  }
</script>

<style lang="scss" scoped>
  .header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .modal-name {
      width: 250px;
    }
  }
</style>
